<template>
	<transition name="slide-fade">
		<div v-if="!disabled && message" :class="messageClass">
			<BaseIcon
				name="warning-circle"
				:class="[
					'h-16px w-16px',
					{
						'text-n-500': !props.isError,
						'text-r-700': props.isError,
					},
				]"
			/>
			<span>{{ message }}</span>
		</div>
	</transition>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'

const props = defineProps({
	errorMessage: {
		type: String,
		default: '',
	},
	infoMessage: {
		type: String,
		default: '',
	},
	isError: {
		type: Boolean,
		default: false,
	},
	disabled: {
		type: Boolean,
		default: false,
	},
})

const message = computed(() =>
	props.isError ? props.errorMessage : props.infoMessage,
)
const messageClass = computed(() => ({
	'flex items-center gap-[4px] ml-[4px] overflow-hidden typography-c2-reg':
		true,
	'text-r-700': props.isError,
	'text-n-500': !props.isError,
}))
</script>

<style></style>
